import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'react-router-redux'
import rootReducer from '../reducers'

export default function configureStore (history, preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(thunk, routerMiddleware(history))
  )
}



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/store/configureStore.prod.js